import { render, staticRenderFns } from "./AddAGFamily.vue?vue&type=template&id=52401a11&scoped=true"
import script from "./AddAGFamily.vue?vue&type=script&lang=js"
export * from "./AddAGFamily.vue?vue&type=script&lang=js"
import style0 from "./AddAGFamily.vue?vue&type=style&index=0&id=52401a11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52401a11",
  null
  
)

export default component.exports